import { Link } from 'react-router-dom'
import { FilePlus, FolderKanban, Inbox, LayoutDashboard, Receipt, RefreshCw } from 'lucide-react'
import { Button } from '@/components/ui/Button'
import {
  FilterBar,
  FilterSelect,
  PageToolbar,
  SegmentTabs,
  ToolbarControlsGroup,
  ToolbarIconButton,
} from '@/components/ui/page-toolbar'
import type { FinanceiroTab } from '@/hooks/useFinanceiroPage'

const TABS = [
  { id: 'dashboard' as const, label: 'Dashboard', icon: LayoutDashboard },
  { id: 'chamados' as const, label: 'Chamados', icon: Inbox },
  { id: 'projetos' as const, label: 'Projetos', icon: FolderKanban },
  { id: 'pagamentos' as const, label: 'Pagamentos', icon: Receipt },
]

type Props = {
  tab: FinanceiroTab
  setTab: (tab: FinanceiroTab) => void
  loading: boolean
  onReload: () => void
  projectFilter: string
  setProjectFilter: (v: string | import('@/hooks/useFinanceiroPage').ProjectFilter) => void
}

export function FinanceiroTopbar({
  tab,
  setTab,
  loading,
  onReload,
  projectFilter,
  setProjectFilter,
}: Props) {
  const projetosFilters =
    tab === 'projetos' ? (
      <FilterBar>
        <FilterSelect
          value={projectFilter}
          onChange={setProjectFilter}
          ariaLabel='Filtrar projetos'
        >
          <option value='todos'>Todos os projetos</option>
          <option value='novos_30d'>Novos (30 dias)</option>
          <option value='sem_contrato'>Sem contrato</option>
          <option value='ativos'>Ativos</option>
        </FilterSelect>
      </FilterBar>
    ) : null

  return (
    <PageToolbar
      navigation={
        <SegmentTabs
          value={tab}
          onChange={(id) => setTab(id as FinanceiroTab)}
          tabs={TABS.map((t) => ({ id: t.id, label: t.label, icon: t.icon }))}
          ariaLabel='Módulo financeiro'
        />
      }
      controls={
        <ToolbarControlsGroup>
          <Link to='/financeiro/solicitacoes'>
            <Button variant='primary' size='sm' type='button'>
              <FilePlus size={14} />
              Nova solicitação
            </Button>
          </Link>
          <ToolbarIconButton
            active={loading}
            onClick={onReload}
            title='Atualizar'
            aria-label='Atualizar'
          >
            <RefreshCw size={16} className={loading ? 'animate-spin' : ''} />
          </ToolbarIconButton>
        </ToolbarControlsGroup>
      }
      filters={projetosFilters ?? undefined}
    />
  )
}
